export const inputContainerStyles = 'flex flex-col w-full gap-[6px]';

export const labelStyles = 'flex flex-row font-semibold text-base leading-6 tracking-[0%]';

export const requiredIndicatorStyles =
  'text-failure font-semibold text-base leading-6 tracking-[0%]';

export const baseInputStyles = `
  bg-input_white 
  text-text_gray_800 
  w-full 
  rounded-lg 
  border 
  border-solid 
  border-border_gray_300 
  px-[14px] 
  py-[10px] 
  gap-[8px] 
  shadow-[0px_1px_2px_0px_#0A0D120D] 
  font-normal 
  text-base 
  leading-6 
  tracking-[0%]
  focus:outline-none
  focus:ring-0
  focus:border-[#D5D7DA]
  focus:bg-input_white
  focus:text-text_gray_800
  disabled:bg-disabled
  disabled:text-text_gray_900
  disabled:cursor-not-allowed
`;

// Compact variant: tighter paddings & smaller font for dense toolbars
export const compactInputStyles = `
  bg-input_white 
  text-text_gray_800 
  w-full 
  rounded-lg 
  border 
  border-solid 
  border-border_gray_300 
  px-[10px] 
  py-[6px] 
  gap-[6px] 
  shadow-[0px_1px_2px_0px_#0A0D120D] 
  font-normal 
  text-sm 
  leading-5 
  tracking-[0%]
  focus:outline-none
  focus:ring-0
  focus:border-[#D5D7DA]
  focus:bg-input_white
  focus:text-text_gray_800
  disabled:bg-disabled
  disabled:text-text_gray_900
  disabled:cursor-not-allowed
`;

export const fixedHeightInputStyles = `${baseInputStyles} h-[44px]`;
export const compactHeightInputStyles = `${compactInputStyles} h-[32px]`;

export interface StandardInputBaseProps {
  id: string;
  label: string;
  isRequired?: boolean;
  placeholderText?: string;
  value: string | number;
  isLoading?: boolean;
}

export const getInputClassName = (prefix: string, variant: 'default' | 'compact' = 'default') => {
  const heightStyles = variant === 'compact' ? compactHeightInputStyles : fixedHeightInputStyles;
  switch (prefix) {
    case 'text':
    case 'number':
    case 'select':
      return `standard-input-${prefix} ${heightStyles}`;
    default:
      return `standard-input-${prefix} ${variant === 'compact' ? compactInputStyles : baseInputStyles}`;
  }
};
